// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4548":"c38fef53","12752":"2023feae","32622":"2023feae","36952":"2023feae","42396":"80b81a22","48825":"c576e1db"}[chunkId] + ".chunk.css";
};